module.exports = __webpack_public_path__ + "img/lcbz5.5f211017.png";